/* eslint-disable array-callback-return, eqeqeq, no-loop-func, no-extra-boolean-cast */

import React, { useState, useEffect, forwardRef } from "react";
import Chip from '@material-ui/core/Chip';
import unflagged_icon from "assets/images/icon-checkbox-round.png";
import flag_icon from "assets/images/icon-checkbox-checked-round.png";
import device_information from "assets/images/device-information.svg"
import icon_radio_outline from "assets/images/icon-radio-outline.svg";
import icon_radio from "assets/images/icon-radio.svg";
import icon_radio_grey_outline from "assets/images/icon-radio-grey-outline.svg";
import icon_radio_grey from "assets/images/icon-radio-grey.svg";
import icon_checkbox_grey_outline from "assets/images/icon-checkbox-grey-outline.svg";
import icon_checkbox_grey from "assets/images/icon-checkbox-grey.svg";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";
import Select from 'react-select';
import { Select as MSelect, TextField, InputAdornment, FormControlLabel, RadioGroup, Radio } from "@material-ui/core";
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import icon_checkbox_checked_round from "assets/images/icon-checkbox-checked-round.png";
import icon_checkbox_round from "assets/images/icon-checkbox-round.png";
import consent_Form_pdf from "assets/images/pdf/Consent_Form.pdf";
import { connect } from "react-redux";
import { TimezoneSelect,allTimezones} from 'timezone-select-js';
import crypto from "crypto";
import PastDateAllocationDevice from 'components/CustomDialogs/DeviceOperations/pastDateAllocationDevice-dialog';
import { validateSearchText } from "common/index";

import {
    fetch_patient_disease as fetch_patient_disease_action,
    fetch_disease_list as fetch_disease_list_action,
    fetch_patient_data as fetch_patient_data_action,
    fetch_patient_data_loading as fetch_patient_data_loading_action,
    set_patient_info_null as set_patient_info_null_action,
    generate_patient_id as generate_patient_id_action,
    update_patient_info as update_patient_info_action,
} from "actions/patients";
import {
    fetch_available_devices as fetch_available_devices_action,
    fetch_available_devices_dates as fetch_available_devices_dates_action,
    reset_device_operation_response as reset_device_operation_response_action,
    reset_patient_password as reset_patient_password_action,
    reset_patient_password_state as reset_patient_password_state_action,
} from 'actions/user';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getLocalMoment } from 'util/timeZoneDate'
import IntlMessages from "util/IntlMessages";
import { defaultWindowEndTime, defaultWindowStartTime } from "util/helpers";

dayjs.extend(utc)
dayjs.extend(customParseFormat)
const currentYear = dayjs().subtract(18, 'years').utc().toDate().getFullYear();
const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => ({ value: start + (i * step), label: start + (i * step) }));
const yearOptions = range(currentYear, currentYear - 100, -1);

const initialQuestionnaire = {
    first: null,
    second: null,
    third: null,
    forth: null,
};

const ViewPatientInfo = (props) => {
    const {
        patients,
        fetch_patient_disease,
        fetch_disease_list,
        fetch_patient_data,
        set_patient_info_null,
        fetch_patient_data_loading,
        update_patient_info,
        user,
        doctor_id,
        match,
        patient_fetching,
        fetch_available_devices_dates,
    } = props;

    const [passwordValues, setPasswordValues] = React.useReducer((i, u) => ({ ...i, ...u }), {
        password: null, confirm: null, passwordError: false, confirmError: false, notSame: false,
        errorResetting: false, resetDone: false
    })

    useEffect(() => {
        props.reset_patient_password_state();
        props.reset_device_operation_response();
        document.getElementById('app-main-content-wrapper').scrollTop = 0;
    }, []);

    const editDeployDevice = window.location.search.substring(1);
    useEffect(() => {
        if (editDeployDevice.split('=')[0] === "deploy_device" && editDeployDevice.split('=')[1] === "true") {
            setEditDeviceSectionFlag(true);
            setTimeout(() => {
                const app_main_content_wrapper = document.getElementById("app-main-content-wrapper");
                app_main_content_wrapper.scrollTo(0, app_main_content_wrapper.scrollHeight);
            }, 500);
        }
    }, [])

    useEffect(() => {
        setPasswordValues({
            errorResetting: user.reset_patient_password_failed,
        })

        if (user.reset_patient_password_success) {
            window.document.querySelector('input#reset-password-field').value = '';
            window.document.querySelector('input#reset-password-confirm-field').value = '';
            setPasswordValues({
                resetDone: true,
                password: null,
                current: null
            })
            setTimeout(() => {
                setPasswordValues({
                    resetDone: false
                })
            }, 5000)
        }
    }, [user.reset_patient_password_failed, user.reset_patient_password_success])

    useEffect(() => {
        fetch_patient_data(match.params.id);
        fetch_disease_list({});
        fetch_available_devices_dates();

        return () => {
            set_patient_info_null()
            fetch_patient_data_loading(false)
        }
    }, [])

    useEffect(() => {
        if (patients.patient_info && patient_fetching === 'loaded') {
            fetch_patient_disease(
                {
                    patient_id: patients.patient_info.user_id,
                    docter_id: doctor_id
                }
            );
        }
    }, [patients.patient_info, patient_fetching]);

    const [pastDateAllocation, setPastDateAllocation] = useState(false);
    const [pastDate, setPastDate] = useState(null);
    const [reqestPastDateDeployDevice, setReqestPastDateDeployDevice] = useState('');
    const [questionnaire, setQuestionnaire] = useState({ ...initialQuestionnaire });
    const [disableSaveDeviceInfoLink, setDisableSaveDeviceInfoLink] = useState(false);
    const [cancelDevice, setCancelDevice] = useState(false);
    const [editBasicSectionFlag, setEditBasicSectionFlag] = useState(false);
    const [editMedicalSectionFlag, setEditMedicalSectionFlag] = useState(false);
    const [editVitalSectionFlag, setEditVitalSectionFlag] = useState(false);
    const [editDeviceSectionFlag, setEditDeviceSectionFlag] = useState(false);
    const [diseaseList, setDiseaseList] = useState([]);
    const [selectedDiseases, setSelectedDiseases] = useState([]);
    const [deviceData, setdeviceData] = useState([]);
    const [searchDeviceId, setSearchDeviceId] = useState('');
    const [greenDotDates, setGreenDotDates] = useState([]);
    const [country, setCountry] = useState({value:'',errors: {}});

    const errors = {
        yearOfBirthError: "",
        genderError: "",
        diseaseError: "",
        weightError: "",
        heightError: "",
        deviceError: ""
    }

    const vitalParamsErrors = {
        vitalsRange: ""
    }

    // if(patients.device_info){
    //     // console.log('check: ', patients.device_info, dayjs(patients.device_info.window_start_time, 'HH:mm:ss').toISOString())
    // }

    const initialValue = {
        gender: patients.patient_info ? patients.patient_info.gender : '',
        weight: patients.patient_info ? patients.patient_info.weight : '',
        height: patients.patient_info ? patients.patient_info.height : '',
        device_deallocation_date: patients.device_info && patients.device_info.device_id ? patients.device_info.device_deallocation_date : dayjs.utc().add(1, 'days').toDate(),
        device_allocation_date: (patients.device_info && patients.device_info.device_id) ? patients.device_info.device_allocation_date : dayjs.utc().toDate(),
        device_master_id: patients.device_info && patients.device_info.device_id ? patients.device_info.device_master_id : "",
        bmi: patients.patient_info ? patients.patient_info.bmi : '',
        user_id: patients.patient_info ? patients.patient_info.user_id : '',
        patient_code: patients.patient_info ? patients.patient_info.patient_code : '',
        first_name: patients.patient_info ? patients.patient_info.first_name : '',
        last_name: patients.patient_info ? patients.patient_info.last_name : '',
        email_id: patients.patient_info ? patients.patient_info.email_id : '',
        date_of_birth: patients.patient_info ? patients.patient_info.date_of_birth : '',
        yearOfBirth: patients.patient_info ? new Date(patients.patient_info.date_of_birth).getFullYear() : '',
        at_risk: patients.patient_info ? patients.patient_info.at_risk : '',
        comment: patients.patient_info ? patients.patient_info.comment : '',
        diseases: "",
        country:patients.patient_info ? patients.patient_info.country : '',
        address: patients.patient_info ? patients.patient_info.address : '',
        tags: patients.patient_info ? patients.patient_info.tags : '',
        device_id: patients.device_info && patients.device_info.device_id ? patients.device_info.device_id : "",
        de_allocate_device: false,
        change_device: false,
        change_allocation_times: false,
        allocate_device: false,
        window_start_time: patients.device_info
      ? dayjs(patients.device_info.window_start_time, 'HH:mm:ss').toISOString()
      : dayjs().toISOString(),
    window_end_time: patients.device_info
      ? dayjs(patients.device_info.window_end_time, 'HH:mm:ss').toISOString()
      : dayjs().toISOString(),

    };

    // Determine the device allocation date edit scenario.
    let today = dayjs.utc();
    let isAllocDateInFuture = false;
    if (initialValue.device_allocation_date) {
        let allocationDate = getLocalMoment(initialValue.device_allocation_date).toDate()
        isAllocDateInFuture = getLocalMoment(allocationDate).isAfter(today);
    }

    const [editPatientForm, setEditPatientForm] = useState(initialValue);
    const [editVitals, setEditVitals] = useState({});
    const [editSpo2Values, setEditSpo2Values] = useState({});
    const [editPRValues, setEditPRValues] = useState({});
    const [editBRValues, setEditBRValues] = useState({});
    const [deviceWindowStartStopTime,setDeviceWindowStartStopTime] = useState({
        window_start_time:null,
        window_end_time:null
    });

    useEffect(() => {
        if (patients.patient_info) {
            const vitals_obj = JSON.parse(patients.patient_info.vital_parameters);
            setEditVitals(vitals_obj);
        }
    }, [patients.patient_info]);
    
    useEffect(() => {
        console.log('user && user.user_details.country',user && user.user_details.country);
        if (patients.device_info) {
          setCountry(ctry => ({
            ...ctry,
            value: patients.device_info ? patients.device_info.timezone : '',
          }));
        } 
        // else {
        //   let tz = dayjs.tz.guess();
        //   if (tz.includes('Calcutta')) {
        //     tz = tz.replace('Calcutta', 'Kolkata');
        //   }
        //   setCountry(ctry => ({
        //     ...ctry,
        //     value: tz,
        //   }));
        // }
      }, [patients.device_info]);

    useEffect(() => {
        if (editVitals.spo2) {
            setEditSpo2Values(editVitals.spo2)
        }
    }, [editVitals]);

    useEffect(() => {
        if (editVitals.pr) {
            setEditPRValues(editVitals.pr)
        }
    }, [editVitals]);

    useEffect(() => {
        if (editVitals.br) {
            setEditBRValues(editVitals.br)
        }
    }, [editVitals]);

    useEffect(() => {
        if (deviceData.length === 1) {
            selectAvailableDevice(null, deviceData[0].device_id);
        }
    }, [deviceData])

    let vital_parameters = {};
    vital_parameters.spo2 = editSpo2Values;
    vital_parameters.br = editBRValues;
    vital_parameters.pr = editPRValues;

    useEffect(() => {
        if (patient_fetching === 'loaded' && patients.patient_info) {
            let fetchedValues = patients.patient_info

            let updatedInitialValue = {
                ...initialValue,
                fetchedValues
            }
            setEditPatientForm(updatedInitialValue)
        }
    }, [patient_fetching]);

    useEffect(() => {
        if (user && user.available_devices_dates && user.available_devices_dates.length > 0) {
            const dates = [];
            user.available_devices_dates.forEach(d => {
                dates.push(new Date(d));
            });

            setGreenDotDates([...dates]);
        }
    }, [user.available_devices_dates]);

    const [formErrors, setFormErrors] = useState(errors);
    const [vitalErrors, setVitalErrors] = useState(vitalParamsErrors);
    const numberOfNights = patients.device_info && patients.device_info.device_deallocation_date && patients.device_info.device_allocation_date ? Math.round(Math.abs(new Date(patients.device_info.device_deallocation_date).getTime() - new Date(patients.device_info.device_allocation_date).getTime()) / 86400000) : "NA";

    useEffect(() => {
        setDiseaseList(patients.fetch_disease_list_data);
    }, [patients.fetch_disease_list_data]);

    useEffect(() => {
        let patientDiseases = selectedDiseases;
        if (patients.fetch_patient_diseases_data) {
            patientDiseases = patients.fetch_patient_diseases_data.map(d => (d.disease_shortname));
        }
        setSelectedDiseases(patientDiseases);
        setEditPatientForm({
            ...editPatientForm,
            diseases: patientDiseases.join(",")
        });
    }, [patients.fetch_patient_diseases_data]);

    useEffect(() => {
        const {
            available_devices,
            device_operation_success_response,
            deployed_device_in_past_date,
            device_operation_error_response
        } = user;

        if (available_devices && available_devices.length > 0) {
            setdeviceData(available_devices);
        } else {
            setdeviceData([]);
        }

        let msg = "";
        if (device_operation_success_response) {
            const { message, details } = device_operation_success_response;
            if (message && details) {
                if (message.indexOf("mapped") > 0) {
                    msg = 'The device is not allocated for the physician for the specified range.'
                } else if (message.indexOf("occupied") > 0) {
                    let patient = details[0].patient_code;
                    let fromDate = getLocalMoment(details[0].device_allocation_date, "DD MMM YYYY");
                    let returnDate = getLocalMoment(details[0].device_deallocation_date, "DD MMM YYYY");
                    if (pastDate) {
                        msg = `This device is already reserved for patient ${patient} from ${fromDate} to ${returnDate}.`
                    } else {
                        msg = `This device is already reserved for patient ${patient} from ${fromDate} to ${returnDate}. To cancel the booking of patient ${patient} and deploy the device for ${editPatientForm.patient_code} click on save again.`
                    }
                } else if (message === `This patient is already assigned to other device during these dates.`) {
                    // msg = message;
                    let fromDate = dayjs.utc(details[0].device_allocation_date).format("DD MMM YYYY");
                    let returnDate = dayjs.utc(details[0].device_deallocation_date).format("DD MMM YYYY");
                    msg = `This patient is already assigned ${details[0].device_id} device for future dates start from ${fromDate} to ${returnDate}.`;
                    // document.getElementsByClassName("popup-content")[0].scrollTo(0, 0);
                }

                setFormErrors({ ...formErrors, deviceError: msg });
                if (pastDate) setPastDateAllocation(true);
            } else if (message && message.indexOf("success") > 0) {
                setFormErrors(errors);
                setCancelDevice(false);
                setEditDeviceSectionFlag(false)
            } else if (message === 'Dates are out of range from physician device allocation.') {
                setFormErrors({ ...formErrors, deviceError: message });
            }
        }
        if (device_operation_error_response) {
            msg = device_operation_error_response.message;
            setFormErrors({ ...formErrors, deviceError: msg });
        }

        let deployed_device_in_past_date_msg = '';
        if (deployed_device_in_past_date && deployed_device_in_past_date.message && deployed_device_in_past_date.message !== "") {
            deployed_device_in_past_date_msg = deployed_device_in_past_date.message;
            const device_information_block = document.getElementById("edit_patient_device_information");
            if (device_information_block) {
                device_information_block.scrollIntoView();
            }
        }
        setReqestPastDateDeployDevice(deployed_device_in_past_date_msg);
    }, [user]);

    useEffect(() => {
        if (!(patients.device_info && patients.device_info.device_id) && editPatientForm.device_allocation_date && editPatientForm.device_deallocation_date && !pastDate) {
            setEditPatientForm({
                ...editPatientForm,
                device_id: null,
            });

            props.fetch_available_devices({
                allocation_time: new Date(editPatientForm.device_allocation_date).getTime(),
                deallocation_time: new Date(editPatientForm.device_deallocation_date).getTime()
            });

            if (editDeviceSectionFlag) {
                setDisableSaveDeviceInfoLink(false);
            }
        }
    }, [editPatientForm.device_allocation_date, editPatientForm.device_deallocation_date]);

    useEffect(() => {
        if (
            !patients.device_info
            && editDeviceSectionFlag
            && editPatientForm.device_id
            && editPatientForm.device_id !== ""
            && questionnaire.first !== 'no'
            && questionnaire.second !== 'no'
            && questionnaire.third !== 'no'
            && questionnaire.third !== 'yes'
        ) {
            setDisableSaveDeviceInfoLink(true);
        }
        let winStart=null, winStop=null;

            user.user_details && user.alloted_devices.forEach((e)=>{
                if(editPatientForm.device_id == e.device_id) {
                    winStart=e.window_start_time;
                    winStop=e.window_end_time;
                }
            })

            user.available_devices && user.available_devices.forEach((e)=>{
                if(editPatientForm.device_id == e.device_id) {
                        winStart=e.window_start_time;
                        winStop=e.window_end_time;
                    }
                })
                
                if (!winStart && !winStop && editPatientForm.device_id) {
                    setDeviceWindowStartStopTime({
                      window_start_time: defaultWindowStartTime,
                      window_end_time: defaultWindowEndTime,
                    });
                  } else {
                    setDeviceWindowStartStopTime({
                      window_start_time: winStart,
                      window_end_time: winStop,
                    });
                  }
    }, [editPatientForm.device_id,deviceWindowStartStopTime.window_start_time]);


    useEffect(() => {
        setEditPatientForm((prev)=>({
            ...prev,
            country:user && user.user_details.country,
        }))
    },[user])

    const handleInputChange = (e, v) => {
        if (v) {
            setCountry({
                value: v ,
              });
  
              setEditPatientForm((prev)=>({
                ...prev,
                country:country.value
            }))
        if (
            questionnaire.first === 'no' &&
            questionnaire.second === 'no' &&
            questionnaire.third === 'no' &&
            questionnaire.forth === 'yes'
            ) {
            setDisableSaveDeviceInfoLink(false);
            }
        }
        // setCountry({ errors: {} });
    };

    const getGenderValue = (gender) => {
        if (gender === "M") {
            return "Male"
        } else if (gender === "F") {
            return "Female"
        } else {
            return "Other"
        }
    };

    const [diseaseMenuOpenFlag, setDiseaseMenuOpenFlag] = useState(false);
    const diseaseMenuToggle = () => {
        setDiseaseMenuOpenFlag(!diseaseMenuOpenFlag);
        if (!diseaseMenuOpenFlag) {
            setDiseaseList(patients.fetch_disease_list_data);
        }
    };

    const onSelectDisease = event => {
        if (patients.fetch_disease_list_data) {
            var disease = patients.fetch_disease_list_data.find(d => d.disease_description === event.currentTarget.dataset.value);
            let remove_none = false, remove_all_but_none = false, other_disease;

            if (disease) {
                // NOTE: don't update if nothing is selected
                if (!event.target.value.length) return;

                if (selectedDiseases.includes("None")) {
                    // NOTE: if event has none and another value selected remove none and select other values
                    if (event.target.value.includes('None') && event.target.value.filter(v => v !== 'None').length) {
                        remove_none = true;
                        event.target.value = event.target.value.filter(v => v !== 'None')
                    }
                } else {
                    // NOTE: if incoming values have none and other values, toggle to none;
                    if (event.target.value.includes('None')) {
                        other_disease = event.target.value.filter(v => v !== 'None');
                        remove_all_but_none = true
                        event.target.value = ['None']
                    }
                }

                if (JSON.stringify(event.target.value) !== JSON.stringify(selectedDiseases)) {
                    fetch_patient_disease(
                        {
                            patient_id: patients.patient_info.user_id,
                            type: "update",
                            disease_id: disease.disease_id,
                            docter_id: user.user_details.user_id
                        }
                    );
                    if (remove_none) {
                        fetch_patient_disease(
                            {
                                patient_id: patients.patient_info.user_id,
                                type: "delete",
                                // NOTE: removes none whose ID is 1
                                disease_id: 1,
                                docter_id: doctor_id
                            }
                        );
                    }
                    if (remove_all_but_none && other_disease && other_disease.length) {
                        for (let i = 0; i < other_disease.length; i++) {
                            const current_disease = patients.fetch_disease_list_data.find(
                                d => d.disease_description == other_disease[i]
                            );
                            fetch_patient_disease(
                                {
                                    patient_id: patients.patient_info.user_id,
                                    type: "delete",
                                    disease_id: current_disease.disease_id,
                                    docter_id: doctor_id
                                }
                            );
                        }
                    }
                } else {
                    fetch_patient_disease(
                        {
                            patient_id: patients.patient_info.user_id,
                            type: "delete",
                            disease_id: disease.disease_id,
                            docter_id: user.user_details.user_id
                        }
                    );
                }
                setSelectedDiseases(event.target.value);
                setFormErrors({ ...formErrors, diseaseError: "" })
            }
        }
    };

    const onDeleteDisease = chip => {
        const chipsData = [...selectedDiseases];
        const chipToDelete = chipsData.indexOf(chip);
        chipsData.splice(chipToDelete, 1);
        setSelectedDiseases(chipsData);
        if (patients.fetch_disease_list_data) {
            var disease = patients.fetch_disease_list_data.find(d => d.disease_description === chip);
            fetch_patient_disease(
                {
                    patient_id: patients.patient_info.user_id,
                    type: "delete",
                    disease_id: disease.disease_id,
                    docter_id: user.user_details.user_id
                }
            );
        }
    };

    const calculate_bmi = () => {
        const { weight, bmi, height } = editPatientForm;
        var finalBmi = bmi;

        if (weight > 0 && height > 0) {
            finalBmi = weight / (height / 100 * height / 100);
            finalBmi = finalBmi.toFixed(2);
        } else {
            finalBmi = 0;
        }

        let bmiState = ""
        if (finalBmi > 0 && finalBmi < 18.5) {
            bmiState = "Underweight";
        } else if (finalBmi >= 18.5 && finalBmi < 25) {
            bmiState = "Normal";
        } else if (finalBmi >= 25 && finalBmi < 30) {
            bmiState = "Pre-obesity";
        } else if (finalBmi >= 30 && finalBmi < 35) {
            bmiState = "Obesity class I";
        } else if (finalBmi >= 35 && finalBmi < 40) {
            bmiState = "Obesity class II";
        } else if (finalBmi > 40) {
            bmiState = "Obesity class III";
        }

        setEditPatientForm({ ...editPatientForm, bmi: finalBmi, bmiState: bmiState })
    };

    const patientInfoBmi = patients.patient_info ? patients.patient_info.bmi : ''
    useEffect(() => {
        calculate_bmi()
    }, [patientInfoBmi, editPatientForm.bmi])

    const CustomDateInput = forwardRef(({ onClick, value }, ref) => (
        <button className="custom-date-input" onClick={onClick} ref={ref}>{value}</button>
    ));

    const vitalParamsValidation = () => {
        let isValid = true;

        let vitalParamsErrMsg = null;
        if (
            editSpo2Values.modFrom === ""
            || editSpo2Values.modTo === ""
            || editSpo2Values.sevFrom === ""
            || editSpo2Values.sevTo === ""
            || editBRValues.modFromF === "" || editBRValues.modToF === ""
            || editBRValues.modFromS === "" || editBRValues.modToS === ""
            || editBRValues.sevFromF === "" || editBRValues.sevToF === ""
            || editBRValues.sevFromS === "" || editBRValues.sevToS === ""
            || editPRValues.modFromF === "" || editPRValues.modToF === ""
            || editPRValues.modFromS === "" || editPRValues.modToS === ""
            || editPRValues.sevFromF === "" || editPRValues.sevToF === ""
            || editPRValues.sevFromS === "" || editPRValues.sevToS === ""
        ) {
            vitalParamsErrMsg = "None of the below inputs should be empty";
            setVitalErrors({ vitalsRange: vitalParamsErrMsg })
            isValid = false && isValid;
        }
        else if
            (
            editSpo2Values.modTo > 100 || editSpo2Values.sevTo > 100
        ) {
            vitalParamsErrMsg = "Spo2 Range cannot be more than 100";
            setVitalErrors({ vitalsRange: vitalParamsErrMsg })
            isValid = false && isValid;
        }
        else if
            (
            editSpo2Values.modFrom > editSpo2Values.modTo
            || editSpo2Values.sevFrom > editSpo2Values.sevTo
            || editBRValues.modFromF > editBRValues.modToF
            || editBRValues.modFromS > editBRValues.modToS
            || editBRValues.sevFromF > editBRValues.sevToF
            || editBRValues.sevFromS > editBRValues.sevToS
            || editPRValues.modFromF > editPRValues.modToF
            || editPRValues.modFromS > editPRValues.modToS
            || editPRValues.sevFromF > editPRValues.sevToF
            || editPRValues.sevFromS > editPRValues.sevToS
        ) {
            vitalParamsErrMsg = "Min. Range should not be greater than Max. Range";
            setVitalErrors({ vitalsRange: vitalParamsErrMsg })
            isValid = false && isValid;
        }

        return isValid;
    };

    const validateMedicalForm = () => {

        let weightErrorText = null;
        if (editPatientForm.weight === "") {
            weightErrorText = "Please enter weight.";
        } else if (editPatientForm.weight == 0) {
            weightErrorText = "Please enter valid weight.";
        }

        let heightErrorText = null;
        if (editPatientForm.height === "") {
            heightErrorText = "Please enter height.";
        } else if (editPatientForm.height == 0) {
            heightErrorText = "Please enter valid height.";
        }

        setFormErrors({
            diseaseError: selectedDiseases.length === 0 ? "Please select condition." : null,
            weightError: weightErrorText,
            heightError: heightErrorText,
        });

        const isValid = vitalParamsValidation();
        if (!isValid) {
            return false;
        }

        if (
            selectedDiseases.length !== 0
            && (editPatientForm.weight && editPatientForm.weight > 0)
            && (editPatientForm.height && editPatientForm.height > 0)
            && editPatientForm.country !== null

            && (editSpo2Values.modFrom && editSpo2Values.modFrom !== "")
            && (editSpo2Values.modTo && editSpo2Values.modTo !== "")
            && (editSpo2Values.sevFrom && editSpo2Values.sevFrom !== "")
            && (editSpo2Values.sevTo && editSpo2Values.sevTo !== "")

            && (editBRValues.modFromF && editBRValues.modFromF !== "")
            && (editBRValues.modToF && editBRValues.modToF !== "")
            && (editBRValues.sevFromF && editBRValues.sevFromF !== "")
            && (editBRValues.sevToF && editBRValues.sevToF !== "")
            && (editBRValues.modFromS && editBRValues.modFromS !== "")
            && (editBRValues.modToS && editBRValues.modToS !== "")
            && (editBRValues.sevFromS && editBRValues.sevFromS !== "")
            && (editBRValues.sevToS && editBRValues.sevToS !== "")

            && (editPRValues.modFromF && editPRValues.modFromF !== "")
            && (editPRValues.modToF && editPRValues.modToF !== "")
            && (editPRValues.sevFromF && editPRValues.sevFromF !== "")
            && (editPRValues.sevToF && editPRValues.sevToF !== "")
            && (editPRValues.modFromS && editPRValues.modFromS !== "")
            && (editPRValues.modToS && editPRValues.modToS !== "")
            && (editPRValues.sevFromS && editPRValues.sevFromS !== "")
            && (editPRValues.sevToS && editPRValues.sevToS !== "")

        ) {
        console.log('---<> IF CHECK  ',editPatientForm.country)

            updatePatientBlock();
        }
    };
    const updatePatientBlock = () => {
        if (editBasicSectionFlag) {
            update_patient_info({ 
                ...editPatientForm, 
                window_start_time: dayjs(editPatientForm.window_start_time).format('HH:mm:ss'),
                window_end_time: dayjs(editPatientForm.window_end_time).format('HH:mm:ss'),
                date_of_birth: dayjs(new Date().setYear(editPatientForm.yearOfBirth)).format("YYYY-MM-DD") 
            });

            setEditPatientForm({ ...editPatientForm, date_of_birth: dayjs(new Date().setYear(editPatientForm.yearOfBirth)).format("YYYY-MM-DD") })
            setEditBasicSectionFlag(!editBasicSectionFlag);
        }

        if (editMedicalSectionFlag) {
            update_patient_info({ ...editPatientForm, date_of_birth: dayjs(new Date().setYear(editPatientForm.yearOfBirth)).format("YYYY-MM-DD") });

            setEditPatientForm({ ...editPatientForm, date_of_birth: dayjs(new Date().setYear(editPatientForm.yearOfBirth)).format("YYYY-MM-DD") })
            if (editPatientForm.weight[editPatientForm.weight.length - 1] === ".") {
                update_patient_info({ ...editPatientForm, weight: parseInt(editPatientForm.weight) })
                setEditPatientForm({ ...editPatientForm, weight: parseInt(editPatientForm.weight) })
            }
            if (editPatientForm.height[editPatientForm.height.length - 1] === ".") {
                update_patient_info({ ...editPatientForm, height: parseInt(editPatientForm.height) })
                setEditPatientForm({ ...editPatientForm, height: parseInt(editPatientForm.height) })
            }
            setEditMedicalSectionFlag(false)
        }
        if (editVitalSectionFlag) {
            update_patient_info({ ...editPatientForm, date_of_birth: dayjs(new Date().setYear(editPatientForm.yearOfBirth)).format("YYYY-MM-DD") });

            setEditPatientForm({ ...editPatientForm, date_of_birth: dayjs(new Date().setYear(editPatientForm.yearOfBirth)).format("YYYY-MM-DD") })
            if (editPatientForm.weight[editPatientForm.weight.length - 1] === ".") {
                update_patient_info({ ...editPatientForm, weight: parseInt(editPatientForm.weight) })
                setEditPatientForm({ ...editPatientForm, weight: parseInt(editPatientForm.weight) })
            }
            if (editPatientForm.height[editPatientForm.height.length - 1] === ".") {
                update_patient_info({ ...editPatientForm, height: parseInt(editPatientForm.height) })
                setEditPatientForm({ ...editPatientForm, height: parseInt(editPatientForm.height) })
            }
            if (!vital_parameters.length) {
                update_patient_info({ ...editPatientForm, vital_parameters: JSON.stringify(vital_parameters) })
            }
            setEditVitalSectionFlag(false)
        }

        if (editDeviceSectionFlag) {
            if (editPatientForm.device_id) {
                if (patients.device_info && patients.device_info.device_id) {
                    update_patient_info({
                        ...editPatientForm,
                        date_of_birth: dayjs(new Date().setYear(editPatientForm.yearOfBirth)).format("YYYY-MM-DD"),
                        change_allocation_times: true,
                        device_user_map_id: patients.device_info.device_user_map_id,
                        force_extend: formErrors.deviceError ? true : false,
                        cancel_device: cancelDevice,
                        window_start_time:deviceWindowStartStopTime.window_start_time,
                        window_end_time:deviceWindowStartStopTime.window_end_time,
                        });
                } else {
                    if (questionnaire.first === 'no' && questionnaire.second === 'no' && questionnaire.third === 'no' && questionnaire.forth === 'yes') {
                        update_patient_info({
                            ...editPatientForm,
                            window_start_time:deviceWindowStartStopTime.window_start_time,
                            window_end_time:deviceWindowStartStopTime.window_end_time,
                            date_of_birth: dayjs(new Date().setYear(editPatientForm.yearOfBirth)).format("YYYY-MM-DD"),
                            allocate_device: true,
                            force_extend: formErrors.deviceError ? true : false,
                        });
                    } else {
                        resetDeviceSelectionData();
                    }
                }
                setEditPatientForm({ ...editPatientForm, date_of_birth: dayjs(new Date().setYear(editPatientForm.yearOfBirth)).format("YYYY-MM-DD") })
            } else {
                resetDeviceSelectionData();

            }
        }
    };

    var calculatedNights = Math.round(Math.abs(new Date(editPatientForm.device_deallocation_date).getTime() - new Date(editPatientForm.device_allocation_date).getTime()) / 86400000);
    const resetDeviceSelectionData = () => {
        props.reset_device_operation_response();

        let list = deviceData;
        list.forEach((device) => {
            device.selected = false;
        });
        setdeviceData(list);

        setEditDeviceSectionFlag(false);
        setDisableSaveDeviceInfoLink(false);
        setEditPatientForm({
            ...editPatientForm,
            device_id: null,
        });
    };

    const toggleQuestionHandle = (order, value) => {
        let qData = { ...questionnaire };
        qData[order] = value;

        if (order === 'first') {
            qData['second'] = null;
            qData['third'] = null;
            qData['forth'] = null;
        }

        if (order === 'second') {
            qData['third'] = null;
            qData['forth'] = null;
        }

        if (order === 'third') {
            qData['forth'] = null;
        }

        setQuestionnaire(qData);

        if (qData.first === 'no' && qData.second === 'no' && qData.third === 'no' && qData.forth === 'yes') {
            if (editPatientForm.country !== null) {
                setDisableSaveDeviceInfoLink(false);
            } else {
              setDisableSaveDeviceInfoLink(true);
            }
        } else {
            setDisableSaveDeviceInfoLink(true);
        }
    };

    const selectAvailableDevice = (e, currentValue) => {
        if (e) e.persist();
        let list = deviceData;
        let deviceMasterID = "";
        let deviceId = null;
        list.forEach((device) => {
            if (currentValue === device.device_id && device.selected !== true) {
                deviceId = currentValue;
                device.selected = true;
                deviceMasterID = device.device_master_id;
            } else {
                device.selected = false;
            }
        })
        setEditPatientForm({
            ...editPatientForm,
            device_id: deviceId,
            country: user && user.user_details.country,
            deviceMasterID: deviceMasterID
        });
        setdeviceData(list);

        if (deviceId === null) {
            setQuestionnaire({ ...initialQuestionnaire });
            setDisableSaveDeviceInfoLink(false);
        } else {
            setTimeout(() => {
                const app_main_content_wrapper = document.getElementById("app-main-content-wrapper");
                app_main_content_wrapper.scrollTo(0, app_main_content_wrapper.scrollHeight);
            }, 1000);
        }
    }
    //console.log("check",props.is_annotator)
    return (
        <div className="patient-information-page">
            <a className="back-link" href="# " onClick={e => {
                e.preventDefault();
                props.history.goBack();
            }}>Go Back</a>
            <div className="patient-information-wrapper">
                <h2 className="add-new-title">
                    {(patients.patient_info && patients.patient_info.patient_code) ? patients.patient_info.patient_code : "-"}
                </h2>
                <div className="patient-block view-patient-block">
                    <div className="patient-block-title">
                        <div className="block-title"><i className="zmdi zmdi-account zmdi-hc-fw"></i><span><IntlMessages id={"newpatient.basic"}></IntlMessages></span></div>
                        <a href="# " onClick={(e) => {
                            e.persist(); e.preventDefault(); setEditBasicSectionFlag(!editBasicSectionFlag);
                            if (e.target.innerText === "SAVE") { validateMedicalForm() }
                        }} className="back-link">{props.is_annotator ? "" : editBasicSectionFlag ? "SAVE" : "EDIT"}</a>

                    </div>
                    {!editBasicSectionFlag ? <div className="field-group view-field-group">
                        <div className="field-block">
                            <label className="field-label"><IntlMessages id="mypatients.patientId"></IntlMessages></label>
                            <div>
                                {
                                    (patients.patient_info && patients.patient_info.patient_code) ? patients.patient_info.patient_code : "-"
                                }
                            </div>
                        </div>
                        <div className="field-block">
                            <label className="field-label"><IntlMessages id="newpatient.yearofBirth"></IntlMessages></label>
                            <div>{editPatientForm.date_of_birth ? new Date(editPatientForm.date_of_birth).getFullYear() : "-"}</div>
                        </div>
                        <div className="field-block">
                            <label className="field-label"><IntlMessages id="newpatient.gender"></IntlMessages></label>
                            <div>{patients.patient_info ? getGenderValue(patients.patient_info.gender) : ''}</div>
                        </div>
                    </div>
                        : <div className="field-group ">
                            <div className="field-block">
                                <label className="field-label star-color-after"><IntlMessages id="mypatients.patientId"></IntlMessages></label>
                                <TextField
                                    variant="outlined"
                                    className="patient-field custom-input"
                                    defaultValue={editPatientForm.patient_code}
                                    disabled
                                    InputProps={{
                                        classes: {
                                            disabled: 'disabled-input'
                                        }
                                    }}
                                />
                            </div>
                            <div className="field-block">
                                <label className="field-label star-color-after"><IntlMessages id="newpatient.yearofBirth"></IntlMessages></label>
                                <Select
                                    placeholder="-- Select --"
                                    type="text"
                                    options={yearOptions}
                                    onChange={(opt) => { setEditPatientForm({ ...editPatientForm, yearOfBirth: opt.value }) }}
                                    isDisabled={false}
                                    isLoading={false}
                                    isClearable={false}
                                    isRtl={false}
                                    isSearchable={true}
                                    noOptionsMessage={() => "Year not found."}
                                    defaultValue={
                                        {
                                            value: editPatientForm.yearOfBirth,
                                            label: editPatientForm.yearOfBirth
                                        }
                                    }
                                    className="patient-field custom-react-select custom-select-box"
                                    classNamePrefix="custom-react-select"
                                >
                                </Select>
                                {(
                                    formErrors.yearOfBirthError && <span className="error-msg">{formErrors.yearOfBirthError}</span>
                                )}
                            </div>
                            <div className="field-block full-block">
                                <label className="field-label star-color-after"><IntlMessages id="newpatient.gender"></IntlMessages></label>
                                <RadioGroup
                                    aria-label="Gender"
                                    name="gender"
                                    className="patient-field radio-group"
                                    value={editPatientForm.gender}
                                    onChange={(e) => { setEditPatientForm({ ...editPatientForm, gender: e.target.value }) }}
                                >
                                    <FormControlLabel
                                        value="M"
                                        control={
                                            <Radio
                                                disableRipple={true}
                                                icon={<img src={icon_radio_outline} alt="Icon" />}
                                                checkedIcon={<img src={icon_radio} alt="Icon" />}
                                                className="custom-radio"
                                                checked={editPatientForm.gender === 'M'}
                                            />
                                        }
                                        label="Male"
                                        className="custom-radio-wrap"
                                        classes={{
                                            label: 'custom-radio-label'
                                        }}
                                    />
                                    <FormControlLabel
                                        value="F"
                                        control={
                                            <Radio
                                                disableRipple={true}
                                                icon={<img src={icon_radio_outline} alt="Icon" />}
                                                checkedIcon={<img src={icon_radio} alt="Icon" />}
                                                className="custom-radio"
                                                selected={editPatientForm.gender === 'F'}
                                            />
                                        }
                                        label="Female"
                                        className="custom-radio-wrap"
                                        classes={{
                                            label: 'custom-radio-label'
                                        }}
                                    />
                                    <FormControlLabel
                                        value="O"
                                        control={
                                            <Radio
                                                disableRipple={true}
                                                icon={<img src={icon_radio_outline} alt="Icon" />}
                                                checkedIcon={<img src={icon_radio} alt="Icon" />}
                                                className="custom-radio"
                                                selected={editPatientForm.gender === 'O'}
                                            />
                                        }
                                        label="Other"
                                        className="custom-radio-wrap"
                                        classes={{
                                            label: 'custom-radio-label'
                                        }}
                                    />
                                </RadioGroup>
                                {(
                                    formErrors.genderError && <span className="error-msg">{formErrors.genderError}</span>
                                )}
                            </div>
                        </div>
                    }
                </div>
                <div className="patient-block view-patient-block">
                    <div className="patient-block-title">
                        <div className="block-title"> <i className="zmdi zmdi-plus-circle-o zmdi-hc-fw"></i> <span><IntlMessages id="main.medicalMsg"></IntlMessages></span></div>
                        <a href="# " onClick={(e) => {
                            e.persist();
                            e.preventDefault(); setEditMedicalSectionFlag(true)
                            if (e.target.innerText === "SAVE") validateMedicalForm()
                        }} className="back-link"> {props.is_annotator ? "" : (!editMedicalSectionFlag && selectedDiseases.length !== 0 && editPatientForm.weight && editPatientForm.height) ? "EDIT" : "SAVE"}</a>
                    </div>
                    {(!editMedicalSectionFlag && selectedDiseases.length !== 0 && editPatientForm.weight && editPatientForm.height && props.is_annotator) ?
                        <React.Fragment>
                            <div className="field-group view-field-group">
                                <div className="field-block diseases-block">
                                    <label className="field-label"><IntlMessages id="newpatient.conditions"></IntlMessages></label>
                                    <div className="selected-options-wrap">
                                        {
                                            selectedDiseases && selectedDiseases.map((value, i) => (
                                                <Chip className="selected-option" key={value + i} label={value} />
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="field-group view-field-group">
                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="newpatient.weight"></IntlMessages></label>
                                    <div>{editPatientForm.weight} kg</div>
                                </div>
                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="newpatient.height"></IntlMessages></label>
                                    <div>{editPatientForm.height} cm</div>
                                </div>
                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="appModule.bmi"></IntlMessages></label>
                                    <div>{editPatientForm.bmi} {"(" + editPatientForm.bmiState + ")"}</div>
                                </div>
                            </div>
                            <div className="label-container" >
                                <label className="field-label">Patient Status</label>
                            </div>
                            <div className="field-group view-field-group">
                                <div className="field-block checkbox-group">
                                    <img alt="Icon" src={editPatientForm.at_risk === null ? flag_icon : unflagged_icon} />
                                    <label className="custom-checkbox-label">Not Known</label>
                                </div>
                                <div className="field-block checkbox-group">
                                    <img alt="Icon" src={editPatientForm.at_risk === 0 ? flag_icon : unflagged_icon} />
                                    <label className="custom-checkbox-label"><IntlMessages id="newpatient.stable"></IntlMessages></label>
                                </div>
                                <div className="field-block checkbox-group">
                                    <img alt="Icon" src={editPatientForm.at_risk === 2 ? flag_icon : unflagged_icon} />
                                    <label className="custom-checkbox-label"><IntlMessages id="newpatient.control"></IntlMessages></label>
                                </div>
                                <div className="field-block checkbox-group">
                                    <img alt="Icon" src={editPatientForm.at_risk === 1 ? flag_icon : unflagged_icon} />
                                    <label className="custom-checkbox-label"><IntlMessages id="newpatient.atRisk"></IntlMessages></label>
                                </div>
                            </div>
                            <div className="field-group view-field-group patient-comment-group">
                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="newpatient.comments"></IntlMessages></label>
                                    <div>{editPatientForm.comment ? editPatientForm.comment : "No comments available"}</div>
                                </div>
                            </div>
                        </React.Fragment>
                        : <React.Fragment>
                            <div className="field-group full-group">
                                <div className="field-block">
                                    <label className="field-label star-color-after"><IntlMessages id="newpatient.conditions"></IntlMessages></label>
                                    <div className="diseaselist-wrap grey-diseaselist-wrap">
                                        <MSelect multiple
                                            classes={{ root: 'diseaselist-root', icon: 'diseaselist-icon', select: 'diseaselist-select', selectMenu: 'diseaselist-select-menu' }}
                                            //value={[]}
                                            value={selectedDiseases}
                                            onChange={onSelectDisease}
                                            MenuProps={
                                                {
                                                    getContentAnchorEl: null,
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "left",
                                                    },
                                                    classes: {
                                                        paper: "diseaselist-dropdown"
                                                    }
                                                }
                                            }
                                            onOpen={diseaseMenuToggle}
                                            open={diseaseMenuOpenFlag}
                                            onClose={diseaseMenuToggle}
                                            className="diseaselist-field"
                                            input={<Input id="select-multiple-checkbox" />}
                                            renderValue={disease_list => disease_list.length + " item" + (disease_list.length > 1 ? "s " : " ") + "selected"}>
                                            <Input className="multiselect-search grey-multiselect-search" id="disease_list_searchBox" placeholder="Search condition" onChange={(e) => {
                                                var inputValue = e.target.value.trim();
                                                var array = [];
                                                array = patients.fetch_disease_list_data.filter(disease => (disease.disease_description.match(new RegExp(inputValue.split('').join('\\w*').replace(/\W/, ""), 'i'))));
                                                setDiseaseList(array);
                                            }}
                                            />
                                            {diseaseList.length > 0 ?
                                                diseaseList.map(disease => (
                                                    <MenuItem className="multi-select-item" key={"d" + disease.disease_id} value={disease.disease_description} >
                                                        <Checkbox
                                                            className="multi-select-check"
                                                            id={"disease-checkbox-" + disease.disease_id}
                                                            checked={selectedDiseases.indexOf(disease.disease_description) > -1}
                                                            icon={<img src={icon_checkbox_grey_outline} alt="Icon" />}
                                                            checkedIcon={<img src={icon_checkbox_grey} alt="Icon" />}
                                                        />
                                                        <ListItemText className="multi-select-text" primary={disease.disease_description} />
                                                    </MenuItem>
                                                )) :
                                                <div className="no-data"><IntlMessages id="newpatient.noConditionFound"></IntlMessages></div>
                                            }
                                        </MSelect>
                                        {(
                                            formErrors.diseaseError && <span className="error-msg">{formErrors.diseaseError}</span>
                                        )}
                                    </div>
                                </div>
                                <div className="selected-options-wrap">
                                    {
                                        selectedDiseases && selectedDiseases.map((value, i) => (
                                            <Chip className="selected-option" key={value + i} label={value} onDelete={() => selectedDiseases.length > 1 && onDeleteDisease(value)} />
                                        ))
                                    }
                                </div>
                            </div>
                            <div className="field-group physical-field-group">
                                <div className="field-block">
                                    <label className="field-label star-color-after"><IntlMessages id="newpatient.weight"></IntlMessages></label>
                                    <TextField
                                        variant="outlined"
                                        name="weightkg"
                                        className="custom-input"
                                        value={editPatientForm.weight}
                                        onChange={(e) => {
                                            if (e.target.value === "" || (e.target.value.length < 7)
                                            ) {
                                                if (Number.isInteger(e.target.value)) {
                                                    if (e.target.value.length < 4) {
                                                        setEditPatientForm({ ...editPatientForm, weight: e.target.value });
                                                        setFormErrors({ ...formErrors, weightError: "" })
                                                    }
                                                } else {
                                                    if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                        setEditPatientForm({ ...editPatientForm, weight: e.target.value });
                                                        setFormErrors({ ...formErrors, weightError: "" })
                                                    }
                                                }
                                            }
                                        }}
                                        onKeyUp={calculate_bmi}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">kg</InputAdornment>,

                                            }
                                        }
                                    />
                                    {(
                                        formErrors.weightError && <span className="error-msg">{formErrors.weightError}</span>
                                    )}
                                </div>
                                <div className="field-block">
                                    <label className="field-label star-color-after"><IntlMessages id="newpatient.height"></IntlMessages></label>
                                    <TextField
                                        variant="outlined"
                                        name="heightkg"
                                        className="custom-input"
                                        value={editPatientForm.height}
                                        onChange={(e) => {
                                            if (e.target.value === "" || (e.target.value.length < 7)) {
                                                if (Number.isInteger(e.target.value)) {
                                                    if (e.target.value.length < 4) {
                                                        setEditPatientForm({ ...editPatientForm, height: e.target.value });
                                                        setFormErrors({ ...formErrors, heightError: "" })
                                                    }
                                                } else {
                                                    if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                        setEditPatientForm({ ...editPatientForm, height: e.target.value });
                                                        setFormErrors({ ...formErrors, heightError: "" })
                                                    }
                                                }
                                            }
                                        }}
                                        onKeyUp={calculate_bmi}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">cm</InputAdornment>,
                                            }
                                        }
                                    />
                                    {(
                                        formErrors.heightError && <span className="error-msg">{formErrors.heightError}</span>
                                    )}
                                </div>
                                <div className="field-block static-field-block">
                                    <label className="field-label"> BMI</label>
                                    <div className="bmi-field">
                                        <strong>{editPatientForm.bmi}</strong><span>{editPatientForm.bmiState ? "(" + editPatientForm.bmiState + ")" : ""}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="label-container" >
                                <label className="field-label star-color-after"><IntlMessages id="newpatient.patientStatus"></IntlMessages></label>
                            </div>
                            <div className="field-group patient-status-flag">
                                <div className="field-block">
                                    <FormControlLabel
                                        className="checkbox-group"
                                        control={
                                            <Checkbox
                                                className="custom-checkbox"
                                                classes={{ checked: 'action-checkbox-checked', disabled: 'action-checkbox-disabled' }}
                                                disableRipple={true}
                                                icon={<img src={icon_checkbox_round} alt="Icon" />}
                                                checkedIcon={<img src={icon_checkbox_checked_round} alt="Icon" />}
                                                checked={editPatientForm.at_risk === false ? true : editPatientForm.at_risk === null}
                                                onChange={() => { setEditPatientForm({ ...editPatientForm, at_risk: null }) }}
                                                defaultValue={editPatientForm.at_risk === null}
                                            />
                                        }
                                        label="Not Known"
                                        classes={{
                                            label: 'custom-checkbox-label'
                                        }}
                                    />
                                </div>
                                <div className="field-block">
                                    <FormControlLabel
                                        className="checkbox-group"
                                        control={
                                            <Checkbox
                                                className="custom-checkbox"
                                                classes={{ checked: 'action-checkbox-checked', disabled: 'action-checkbox-disabled' }}
                                                disableRipple={true}
                                                icon={< img src={icon_checkbox_round} alt="Icon" />}
                                                checkedIcon={< img src={icon_checkbox_checked_round} alt="Icon" />}
                                                checked={editPatientForm.at_risk === 0}
                                                onChange={() => { setEditPatientForm({ ...editPatientForm, at_risk: 0 }) }}
                                            // defaultValue={editPatientForm.at_risk === 0}
                                            />
                                        }
                                        label="Stable"
                                        classes={
                                            {
                                                label: 'custom-checkbox-label'
                                            }
                                        }
                                    />
                                </div>
                                <div className="field-block">
                                    <FormControlLabel
                                        className="checkbox-group"
                                        control={
                                            <Checkbox
                                                className="custom-checkbox"
                                                classes={{ checked: 'action-checkbox-checked', disabled: 'action-checkbox-disabled' }}
                                                disableRipple={true}
                                                icon={< img src={icon_checkbox_round} alt="Icon" />}
                                                checkedIcon={< img src={icon_checkbox_checked_round} alt="Icon" />}
                                                checked={editPatientForm.at_risk === 2}
                                                onChange={() => { setEditPatientForm({ ...editPatientForm, at_risk: 2 }) }}
                                                defaultValue={editPatientForm.at_risk === 2}
                                            />
                                        }
                                        label="Control"
                                        classes={
                                            {
                                                label: 'custom-checkbox-label'
                                            }
                                        }
                                    />
                                </div>
                                <div className="field-block">
                                    <FormControlLabel
                                        className="checkbox-group"
                                        control={
                                            < Checkbox
                                                className="custom-checkbox"
                                                classes={{ checked: 'action-checkbox-checked', disabled: 'action-checkbox-disabled' }}
                                                disableRipple={true}
                                                icon={< img src={icon_checkbox_round} alt="Icon" />}
                                                checkedIcon={< img src={icon_checkbox_checked_round} alt="Icon" />}
                                                checked={editPatientForm.at_risk === 1}
                                                onChange={() => { setEditPatientForm({ ...editPatientForm, at_risk: 1 }) }}
                                                defaultValue={editPatientForm.at_risk === 1}
                                            />
                                        }
                                        label="At Risk"
                                        classes={
                                            {
                                                label: 'custom-checkbox-label'
                                            }
                                        }
                                    />
                                </div>
                            </div>
                            <div className="field-group patient-comment-group">
                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="newpatient.comments"></IntlMessages></label>
                                    <TextField
                                        className="comment-textarea"
                                        type="textarea"
                                        value={editPatientForm.comment}
                                        onChange={(e) => {
                                            if (e.target.value.length <= 1024) {
                                                setEditPatientForm({ ...editPatientForm, comment: e.target.value })
                                            }
                                        }
                                        }
                                        variant="outlined"
                                        multiline={true}
                                        rows={3}
                                        rowsMax={4}
                                        fullWidth

                                    />
                                </div>
                            </div>
                        </React.Fragment>
                    }
                </div>
                <div className="patient-block view-patient-block">
                    <div className="patient-block-title">
                        <div className="block-title"> <i className="zmdi zmdi-plus-circle-o zmdi-hc-fw"></i> <span><IntlMessages id="editPatient.vitalThresholds"></IntlMessages></span></div>
                        <span>
                            {(
                                vitalErrors.vitalsRange && <span className="error-msg-vitals">{vitalErrors.vitalsRange}</span>
                            )}
                        </span>
                        <a href="# " onClick={(e) => {
                            e.persist();
                            e.preventDefault(); setEditVitalSectionFlag(true)
                            if (e.target.innerText === "SAVE") validateMedicalForm()
                        }} className="back-link"> {props.is_annotator ? "" : (!editVitalSectionFlag) ? "EDIT" : "SAVE"}</a>
                    </div>
                    {(!editVitalSectionFlag) ?
                        <React.Fragment>
                            <div className="field-group view-field-group">
                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="main.breathingRate"></IntlMessages> (bpm)</label>
                                    <br></br>
                                    <div className="field-label"><IntlMessages id="editPatient.moderate"></IntlMessages></div>
                                    <div>{editBRValues.modFromF} To {editBRValues.modToF}</div>
                                    <div>{editBRValues.modFromS} To {editBRValues.modToS}</div>
                                    <br></br>
                                    <div className="field-label"><IntlMessages id="editPatient.severe"></IntlMessages></div>
                                    <div>{editBRValues.sevFromF} To {editBRValues.sevToF}</div>
                                    <div>{editBRValues.sevFromS} To {editBRValues.sevToS}</div>
                                </div>
                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="main.pulseRate"></IntlMessages> (beats/min)</label>
                                    <br></br>
                                    <div className="field-label"><IntlMessages id="editPatient.moderate"></IntlMessages></div>
                                    <div>{editPRValues.modFromF} To {editPRValues.modToF}</div>
                                    <div>{editPRValues.modFromS} To {editPRValues.modToS}</div>
                                    <br></br>
                                    <div className="field-label"><IntlMessages id="editPatient.severe"></IntlMessages></div>
                                    <div>{editPRValues.sevFromF} To {editPRValues.sevToF}</div>
                                    <div>{editPRValues.sevFromS} To {editPRValues.sevToS}</div>
                                </div>
                                <div className="field-block">
                                    <label className="field-label"> SPO2 (%)</label>
                                    <br></br>
                                    <div className="field-label"><IntlMessages id="editPatient.moderate"></IntlMessages></div>
                                    <div>{editSpo2Values.modFrom} To {editSpo2Values.modTo}</div>
                                    <br></br>
                                    <div className="field-label"><IntlMessages id="editPatient.severe"></IntlMessages></div>
                                    <div>{editSpo2Values.sevFrom} To {editSpo2Values.sevTo}</div>
                                </div>
                            </div>
                        </React.Fragment>
                        : <React.Fragment>
                            <div className="field-group full-group">
                                <span>
                                    <label className="field-label star-color-after"> <IntlMessages id="main.breathingRate"></IntlMessages></label>
                                </span>
                                <span style={{ marginLeft: '260px' }}>
                                    <label className="field-label star-color-after"><IntlMessages id="main.pulseRate"></IntlMessages></label>
                                </span>
                                <span style={{ marginLeft: '298px' }}>
                                    <label className="field-label star-color-after">SPO2</label>
                                </span>
                                <div style={{ maxWidth: '127px' }}>
                                    <label className="field-label star-color-after"><IntlMessages id="editPatient.moderate"></IntlMessages></label>
                                    <TextField
                                        variant="outlined"
                                        name="modFromF"
                                        className="custom-input"
                                        value={editBRValues.modFromF}
                                        onChange={(e) => {
                                            if (Number.isInteger(e.target.value)) {
                                                if (e.target.value.length < 4) {
                                                    const { name, value } = e.target;
                                                    setEditBRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            } else {
                                                if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                    const { name, value } = e.target;
                                                    setEditBRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            }
                                        }}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">bpm</InputAdornment>,

                                            }
                                        }
                                    />
                                    <TextField
                                        variant="outlined"
                                        name="modFromS"
                                        className="custom-input"
                                        value={editBRValues.modFromS}
                                        onChange={(e) => {
                                            if (Number.isInteger(e.target.value)) {
                                                if (e.target.value.length < 4) {
                                                    const { name, value } = e.target;
                                                    setEditBRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            } else {
                                                if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                    const { name, value } = e.target;
                                                    setEditBRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            }
                                        }}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">bpm</InputAdornment>,

                                            }
                                        }
                                    />
                                </div>
                                <div style={{ maxWidth: '127px' }}>
                                    <label className="field-label star-color-after"> <IntlMessages id="editPatient.severe"></IntlMessages></label>
                                    <TextField
                                        variant="outlined"
                                        name="sevFromF"
                                        className="custom-input"
                                        value={editBRValues.sevFromF}
                                        onChange={(e) => {
                                            if (Number.isInteger(e.target.value)) {
                                                if (e.target.value.length < 4) {
                                                    const { name, value } = e.target;
                                                    setEditBRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            } else {
                                                if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                    const { name, value } = e.target;
                                                    setEditBRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            }
                                        }}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">bpm</InputAdornment>,

                                            }
                                        }
                                    />
                                    <TextField
                                        variant="outlined"
                                        name="sevFromS"
                                        className="custom-input"
                                        value={editBRValues.sevFromS}
                                        onChange={(e) => {
                                            if (Number.isInteger(e.target.value)) {
                                                if (e.target.value.length < 4) {
                                                    const { name, value } = e.target;
                                                    setEditBRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            } else {
                                                if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                    const { name, value } = e.target;
                                                    setEditBRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            }
                                        }}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">bpm</InputAdornment>,

                                            }
                                        }
                                    />
                                </div>
                            </div>
                            <div style={{ marginLeft: '138px', marginTop: '-201px', maxWidth: '127px' }}>
                                <div style={{ marginTop: '16px' }}>
                                    <TextField
                                        variant="outlined"
                                        name="modToF"
                                        className="custom-input"
                                        value={editBRValues.modToF}
                                        onChange={(e) => {
                                            if (Number.isInteger(e.target.value)) {
                                                if (e.target.value.length < 4) {
                                                    const { name, value } = e.target;
                                                    setEditBRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            } else {
                                                if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                    const { name, value } = e.target;
                                                    setEditBRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            }
                                        }}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">bpm</InputAdornment>,

                                            }
                                        }
                                    />
                                    <TextField
                                        variant="outlined"
                                        name="modToS"
                                        className="custom-input"
                                        value={editBRValues.modToS}
                                        onChange={(e) => {
                                            if (Number.isInteger(e.target.value)) {
                                                if (e.target.value.length < 4) {
                                                    const { name, value } = e.target;
                                                    setEditBRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            } else {
                                                if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                    const { name, value } = e.target;
                                                    setEditBRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            }
                                        }}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">bpm</InputAdornment>,

                                            }
                                        }
                                    />
                                </div>
                                <br></br>
                                <br></br>
                                <div style={{ marginTop: '-20px' }}>
                                    <TextField
                                        variant="outlined"
                                        name="sevToF"
                                        className="custom-input"
                                        value={editBRValues.sevToF}
                                        onChange={(e) => {
                                            if (Number.isInteger(e.target.value)) {
                                                if (e.target.value.length < 4) {
                                                    const { name, value } = e.target;
                                                    setEditBRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            } else {
                                                if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                    const { name, value } = e.target;
                                                    setEditBRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            }
                                        }}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">bpm</InputAdornment>,

                                            }
                                        }
                                    />
                                    <TextField
                                        variant="outlined"
                                        name="sevToS"
                                        className="custom-input"
                                        value={editBRValues.sevToS}
                                        onChange={(e) => {
                                            if (Number.isInteger(e.target.value)) {
                                                if (e.target.value.length < 4) {
                                                    const { name, value } = e.target;
                                                    setEditBRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            } else {
                                                if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                    const { name, value } = e.target;
                                                    setEditBRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            }
                                        }}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">bpm</InputAdornment>,

                                            }
                                        }
                                    />
                                </div>
                            </div>
                            <div className="field-group full-group">
                                <label className="field-label"></label>
                                <div style={{ maxWidth: '127px', marginLeft: '360px', marginTop: '-223px' }}>
                                    <label className="field-label star-color-after"><IntlMessages id="editPatient.moderate"></IntlMessages></label>
                                    <TextField
                                        variant="outlined"
                                        name="modFromF"
                                        className="custom-input"
                                        value={editPRValues.modFromF}
                                        onChange={(e) => {
                                            if (Number.isInteger(e.target.value)) {
                                                if (e.target.value.length < 4) {
                                                    const { name, value } = e.target;
                                                    setEditPRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            } else {
                                                if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                    const { name, value } = e.target;
                                                    setEditPRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            }
                                        }}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">b/m</InputAdornment>,

                                            }
                                        }
                                    />
                                    <TextField
                                        variant="outlined"
                                        name="modFromS"
                                        className="custom-input"
                                        value={editPRValues.modFromS}
                                        onChange={(e) => {
                                            if (Number.isInteger(e.target.value)) {
                                                if (e.target.value.length < 4) {
                                                    const { name, value } = e.target;
                                                    setEditPRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            } else {
                                                if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                    const { name, value } = e.target;
                                                    setEditPRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            }
                                        }}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">b/m</InputAdornment>,

                                            }
                                        }
                                    />
                                </div>
                                <div style={{ maxWidth: '127px', marginLeft: '360px' }}>
                                    <label className="field-label star-color-after"> <IntlMessages id="editPatient.severe"></IntlMessages></label>
                                    <TextField
                                        variant="outlined"
                                        name="sevFromF"
                                        className="custom-input"
                                        value={editPRValues.sevFromF}
                                        onChange={(e) => {
                                            if (Number.isInteger(e.target.value)) {
                                                if (e.target.value.length < 4) {
                                                    const { name, value } = e.target;
                                                    setEditPRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            } else {
                                                if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                    const { name, value } = e.target;
                                                    setEditPRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            }
                                        }}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">b/m</InputAdornment>,

                                            }
                                        }
                                    />
                                    <TextField
                                        variant="outlined"
                                        name="sevFromS"
                                        className="custom-input"
                                        value={editPRValues.sevFromS}
                                        onChange={(e) => {
                                            if (Number.isInteger(e.target.value)) {
                                                if (e.target.value.length < 4) {
                                                    const { name, value } = e.target;
                                                    setEditPRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            } else {
                                                if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                    const { name, value } = e.target;
                                                    setEditPRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            }
                                        }}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">b/m</InputAdornment>,

                                            }
                                        }
                                    />
                                </div>
                            </div>
                            <div style={{ marginLeft: '500px', marginTop: '-203px', maxWidth: '127px' }}>
                                <div style={{ marginTop: '16px' }}>
                                    <TextField
                                        variant="outlined"
                                        name="modToF"
                                        className="custom-input"
                                        value={editPRValues.modToF}
                                        onChange={(e) => {
                                            if (Number.isInteger(e.target.value)) {
                                                if (e.target.value.length < 4) {
                                                    const { name, value } = e.target;
                                                    setEditPRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            } else {
                                                if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                    const { name, value } = e.target;
                                                    setEditPRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            }
                                        }}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">b/m</InputAdornment>,

                                            }
                                        }
                                    />
                                    <TextField
                                        variant="outlined"
                                        name="modToS"
                                        className="custom-input"
                                        value={editPRValues.modToS}
                                        onChange={(e) => {
                                            if (Number.isInteger(e.target.value)) {
                                                if (e.target.value.length < 4) {
                                                    const { name, value } = e.target;
                                                    setEditPRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            } else {
                                                if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                    const { name, value } = e.target;
                                                    setEditPRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            }
                                        }}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">b/m</InputAdornment>,

                                            }
                                        }
                                    />
                                </div>
                                <br></br>
                                <br></br>
                                <div style={{ marginTop: '-20px' }}>
                                    <TextField
                                        variant="outlined"
                                        name="sevToF"
                                        className="custom-input"
                                        value={editPRValues.sevToF}
                                        onChange={(e) => {
                                            if (Number.isInteger(e.target.value)) {
                                                if (e.target.value.length < 4) {
                                                    const { name, value } = e.target;
                                                    setEditPRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            } else {
                                                if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                    const { name, value } = e.target;
                                                    setEditPRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            }
                                        }}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">b/m</InputAdornment>,

                                            }
                                        }
                                    />
                                    <TextField
                                        variant="outlined"
                                        name="sevToS"
                                        className="custom-input"
                                        value={editPRValues.sevToS}
                                        onChange={(e) => {
                                            if (Number.isInteger(e.target.value)) {
                                                if (e.target.value.length < 4) {
                                                    const { name, value } = e.target;
                                                    setEditPRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            } else {
                                                if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                    const { name, value } = e.target;
                                                    setEditPRValues(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            }
                                        }}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">b/m</InputAdornment>,

                                            }
                                        }
                                    />
                                </div>
                            </div>
                            <div className="field-group full-group">
                                <label className="field-label"></label>
                                <div style={{ maxWidth: '127px', marginLeft: '735px', marginTop: '-223px' }}>
                                    <label className="field-label star-color-after"> <IntlMessages id="editPatient.moderate"></IntlMessages></label>
                                    <TextField
                                        variant="outlined"
                                        name="modFrom"
                                        className="custom-input"
                                        value={editSpo2Values.modFrom}
                                        onChange={(e) => {
                                            if (Number.isInteger(e.target.value)) {
                                                if (e.target.value.length < 4) {
                                                    const { name, value } = e.target;
                                                    setEditSpo2Values(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            } else {
                                                if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                    const { name, value } = e.target;
                                                    setEditSpo2Values(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            }
                                        }}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">%</InputAdornment>,

                                            }
                                        }
                                    />
                                </div>
                                <div style={{ maxWidth: '127px', marginLeft: '874px', marginTop: '-38px' }}>
                                    <TextField
                                        variant="outlined"
                                        name="modTo"
                                        className="custom-input"
                                        value={editSpo2Values.modTo}
                                        onChange={(e) => {
                                            if (Number.isInteger(e.target.value)) {
                                                if (e.target.value.length < 4) {
                                                    const { name, value } = e.target;
                                                    setEditSpo2Values(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            } else {
                                                if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                    const { name, value } = e.target;
                                                    setEditSpo2Values(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            }
                                        }}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">%</InputAdornment>,

                                            }
                                        }
                                    />
                                </div>
                                <br></br>
                                <div style={{ maxWidth: '127px', marginLeft: '735px' }}>
                                    <label className="field-label star-color-after"> <IntlMessages id="editPatient.severe"></IntlMessages></label>
                                    <TextField
                                        variant="outlined"
                                        name="sevFrom"
                                        className="custom-input"
                                        value={editSpo2Values.sevFrom}
                                        onChange={(e) => {
                                            if (Number.isInteger(e.target.value)) {
                                                if (e.target.value.length < 4) {
                                                    const { name, value } = e.target;
                                                    setEditSpo2Values(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            } else {
                                                if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                    const { name, value } = e.target;
                                                    setEditSpo2Values(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            }
                                        }}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">%</InputAdornment>,

                                            }
                                        }
                                    />
                                </div>
                                <div style={{ maxWidth: '127px', marginLeft: '874px', marginTop: '-39px' }}>
                                    <TextField
                                        variant="outlined"
                                        name="sevTo"
                                        className="custom-input"
                                        value={editSpo2Values.sevTo}
                                        onChange={(e) => {
                                            if (Number.isInteger(e.target.value)) {
                                                if (e.target.value.length < 4) {
                                                    const { name, value } = e.target;
                                                    setEditSpo2Values(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            } else {
                                                if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                                    const { name, value } = e.target;
                                                    setEditSpo2Values(prevState => ({
                                                        ...prevState,
                                                        [name]: value
                                                    }));
                                                    setVitalErrors({ ...vitalErrors, vitalsRange: "" })
                                                }
                                            }
                                        }}
                                        InputProps={
                                            {
                                                endAdornment: <InputAdornment className="input-unit" position="end">%</InputAdornment>,

                                            }
                                        }
                                    />
                                </div>
                            </div>
                        </React.Fragment>
                    }
                </div>
                <div className="patient-block view-patient-block" id="edit_patient_device_information">
                    <div className="patient-block-title">
                        <div className="block-title"> <img src={device_information} alt="Icon" /> <span><IntlMessages id="newpatient.deviceInformation"></IntlMessages></span>
                        </div>
                        {Boolean(patients.patient_info && patients.patient_info.active_flag) && <a
                            href="# "
                            onClick={(e) => {
                                e.persist();
                                e.preventDefault();
                                setEditDeviceSectionFlag(true);
                                if (e.target.innerText === "SAVE") {
                                    validateMedicalForm()
                                }
                            }}
                            className={"back-link " + (disableSaveDeviceInfoLink ? "disabled-link" : "")}
                        >
                            {props.is_annotator ? "" : !editDeviceSectionFlag ? "EDIT" : "SAVE"}
                        </a>}
                    </div>
                    {formErrors.deviceError && <div className="error-msg device-err">{formErrors.deviceError}</div>}
                    {(patients.device_info && patients.device_info.device_id) ?
                        <>
                            <div className="field-group view-field-group" >
                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="mypatients.deviceId"></IntlMessages></label>
                                    <div>{patients.device_info && patients.device_info.device_id ? patients.device_info.device_id : "NA"}</div>
                                </div>
                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="newpatient.deviceAllocation"></IntlMessages></label>
                                    {
                                        (editDeviceSectionFlag && isAllocDateInFuture)
                                            ?
                                            <div className="grey-calendar-wrapper">
                                                <DatePicker
                                                    minDate={getLocalMoment(today).toDate()}
                                                    maxDate={getLocalMoment(editPatientForm.device_deallocation_date).add(-1, 'days').toDate()}
                                                    selected={getLocalMoment(editPatientForm.device_allocation_date).toDate()}
                                                    dateFormat="dd MMM yyyy"
                                                    calendarClassName="custom-calendar grey-calendar"
                                                    customInput={<CustomDateInput />}
                                                    onChange={
                                                        (date) => {
                                                            setEditPatientForm({ ...editPatientForm, device_allocation_date: date })
                                                        }
                                                    }
                                                    renderCustomHeader={
                                                        ({
                                                            date,
                                                            decreaseMonth,
                                                            increaseMonth,
                                                            prevMonthButtonDisabled,
                                                            nextMonthButtonDisabled
                                                        }) => (
                                                            <div className="calendar-controls">
                                                                <div className="left-controls">
                                                                    <span>{getLocalMoment(date, 'MMMM')} </span>
                                                                    <span>{getLocalMoment(date, 'YYYY')}</span>
                                                                </div>
                                                                <div className="right-controls">
                                                                    <span className="zmdi zmdi-chevron-left zmdi-hc-fw" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}></span>
                                                                    <span className="zmdi zmdi-chevron-right zmdi-hc-fw" onClick={increaseMonth} disabled={nextMonthButtonDisabled}></span>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                />
                                            </div>
                                            :
                                            <div>{patients.device_info && patients.device_info.device_allocation_date ? getLocalMoment(patients.device_info.device_allocation_date, "DD MMM YYYY") : "NA"}</div>
                                    }
                                </div>
                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="newpatient.deviceReturn"></IntlMessages></label>
                                    {!editDeviceSectionFlag ? <div>{patients.device_info && patients.device_info.device_deallocation_date ? getLocalMoment(patients.device_info.device_deallocation_date, "DD MMM YYYY") : "NA"}</div> :
                                        <div className="grey-calendar-wrapper">
                                            {/* TODO: check why date showing one number extra */}
                                            <DatePicker
                                                minDate={dayjs.utc(editPatientForm.device_allocation_date).add(1, 'days').toDate()}
                                                selected={getLocalMoment(editPatientForm.device_deallocation_date).toDate() || dayjs.utc(editPatientForm.device_allocation_date).add(1, 'days').toDate()}
                                                dateFormat="dd MMM yyyy"
                                                calendarClassName="custom-calendar grey-calendar"
                                                customInput={<CustomDateInput />}
                                                onChange={
                                                    (date) => {
                                                        setEditPatientForm({ ...editPatientForm, device_deallocation_date: date })
                                                    }
                                                }
                                                renderCustomHeader={
                                                    ({
                                                        date,
                                                        decreaseMonth,
                                                        increaseMonth,
                                                        prevMonthButtonDisabled,
                                                        nextMonthButtonDisabled
                                                    }) => (
                                                        <div className="calendar-controls">
                                                            <div className="left-controls">
                                                                <span>{getLocalMoment(date, 'MMMM')} </span>
                                                                <span>{getLocalMoment(date, 'YYYY')}</span>
                                                            </div>
                                                            <div className="right-controls">
                                                                <span className="zmdi zmdi-chevron-left zmdi-hc-fw" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}></span>
                                                                <span className="zmdi zmdi-chevron-right zmdi-hc-fw" onClick={increaseMonth} disabled={nextMonthButtonDisabled}></span>
                                                            </div>
                                                        </div>
                                                    )}
                                            />
                                        </div>
                                    }
                                </div>
                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="newpatient.duration"></IntlMessages></label>
                                    <div>{calculatedNights} {calculatedNights > 1 ? " Nights" : " Night"}</div>
                                </div>
                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="newpatient.timezone"></IntlMessages></label>
                                    <div>{patients.device_info ? patients.device_info.timezone : 'N/A'}</div>
                                </div>
                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="newpatient.startTime"></IntlMessages></label>
                                    <div>{deviceWindowStartStopTime.window_start_time ? deviceWindowStartStopTime.window_start_time : 'N/A'}</div>
                                </div>
                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="newpatient.stopTime"></IntlMessages></label>
                                    <div>{deviceWindowStartStopTime.window_end_time ? deviceWindowStartStopTime.window_end_time : 'N/A'}</div>
                                </div>
                        </div>
                            {
                                editDeviceSectionFlag && isAllocDateInFuture
                                && (
                                    <div>
                                        <div className="field-group">
                                            <div className="field-block">
                                                <FormControlLabel
                                                    className="checkbox-group"
                                                    control={
                                                        <Checkbox
                                                            className="custom-checkbox"
                                                            classes={{ checked: 'action-checkbox-checked', disabled: 'action-checkbox-disabled' }}
                                                            disableRipple={true}
                                                            icon={<img src={icon_checkbox_round} alt="Icon" />}
                                                            checkedIcon={<img src={icon_checkbox_checked_round} alt="Icon" />}
                                                            checked={cancelDevice}
                                                            onChange={(e) => { setCancelDevice(e.target.checked) }}
                                                        />
                                                    }
                                                    label="Cancel Device Allocation"
                                                    classes={{
                                                        label: 'custom-checkbox-label'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    {/* <div className="field-block pb-4">
                                            <label className="field-label py-2 star-color-after"><IntlMessages id="mypatients.timezone"></IntlMessages></label>
                                             <TimezoneSelect
                                            timezones={{
                                                ...allTimezones,
                                            }}
                                            labelStyle='original'
                                                value={country.value ? country.value : user.user_details.country}
                                                onChange={v => handleInputChange('country', v.value)}
                                                required={true}
                                                id="country"
                                                name="country"
                                            />
                                        </div>  */}
                                    </div>
                                )
                            }
                        </>
                        :
                        !editDeviceSectionFlag ?
                            <div className="field-group view-field-group">
                                <div className="field-block">
                                    <label className="field-label"> <IntlMessages id="mypatients.deviceId"></IntlMessages></label>
                                    <div>{patients.device_info && patients.device_info.device_id ? patients.device_info.device_id : "NA"}</div>
                                </div>
                                <div className="field-block">
                                    <label className="field-label"> <IntlMessages id="newpatient.deviceAllocation"></IntlMessages></label>
                                    <div>{patients.device_info && patients.device_info.device_allocation_date ? getLocalMoment(patients.device_info.device_allocation_date, "DD MMM YYYY") : "NA"}</div>
                                </div>
                                <div className="field-block">
                                    <label className="field-label"> <IntlMessages id="newpatient.deviceReturn"></IntlMessages></label>
                                    <div>{patients.device_info && patients.device_info.device_deallocation_date ? getLocalMoment(patients.device_info.device_deallocation_date, "DD MMM YYYY") : "NA"}</div>
                                </div>
                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="newpatient.duration"></IntlMessages></label >
                                    <div>{Number(numberOfNights) ? numberOfNights > 1 ? numberOfNights + " Nights" : numberOfNights + " Night" : "NA"}</div>
                                </div>
                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="newpatient.timezone"></IntlMessages></label>
                                    <div>{patients.device_info ? patients.device_info.timezone : 'N/A'}</div>
                                </div>
                                <div className="field-block">
                                    <label className="field-label">
                                        <IntlMessages id="newpatient.startTime"></IntlMessages>
                                    </label>
                                    <div>
                                    {patients.device_info
                                        ? patients.device_info.window_start_time
                                        : 'N/A'}
                                    </div>
                                </div>
                                <div className="field-block">
                                    <label className="field-label">
                                    <IntlMessages id="newpatient.stopTime"></IntlMessages>
                                    </label>
                                    <div>
                                    {patients.device_info
                                        ? patients.device_info.window_end_time
                                        : 'N/A'}
                                    </div>
                                </div>
                            </div> :
                            <>
                                {
                                    reqestPastDateDeployDevice
                                    && (
                                        <div className="field-group error-msg">{reqestPastDateDeployDevice}</div>
                                    )
                                }
                                <div className="field-group">
                                    <div className="device-info-left">
                                        <div className="calendar-field">
                                            <label className="field-label"><IntlMessages id="newpatient.deviceAllocation"></IntlMessages></label>
                                            <div className="grey-calendar-wrapper green-dots-calendar">
                                                <DatePicker
                                                    // minDate={moment.utc().toDate()}
                                                    selected={editPatientForm.device_allocation_date ? dayjs.utc(editPatientForm.device_allocation_date).toDate() : dayjs.utc().toDate()}
                                                    dateFormat="dd MMM yyyy"
                                                    calendarClassName="custom-calendar grey-calendar"
                                                    customInput={<CustomDateInput />}
                                                    highlightDates={greenDotDates}
                                                    onChange={(date) => {
                                                        if (dayjs.utc(date).format('YYYY-MM-DD') >= dayjs.utc().format('YYYY-MM-DD')) {
                                                            let dates_selection = { device_allocation_date: date }
                                                            if (dayjs.utc(date).format('YYYY-MM-DD') >= dayjs.utc(editPatientForm.device_deallocation_date).format('YYYY-MM-DD')) {
                                                                dates_selection = { ...dates_selection, device_deallocation_date: dayjs.utc(date).add(1, 'days').toDate() }
                                                            } else if (!editPatientForm.device_deallocation_date) {
                                                                dates_selection = { ...dates_selection, device_deallocation_date: dayjs.utc(date).add(1, 'days').toDate() }
                                                            }
                                                            setEditPatientForm({ ...editPatientForm, ...dates_selection });
                                                            setPastDate(null);
                                                            setPastDateAllocation(false);
                                                        } else {
                                                            setPastDate(date);
                                                            setPastDateAllocation(true);
                                                        }
                                                    }}
                                                    renderCustomHeader={({
                                                        date,
                                                        decreaseMonth,
                                                        increaseMonth,
                                                        prevMonthButtonDisabled,
                                                        nextMonthButtonDisabled
                                                    }) => (
                                                        <div className="calendar-controls">
                                                            <div className="left-controls">
                                                                <span>{getLocalMoment(date, 'MMMM')} </span>
                                                                <span>{getLocalMoment(date, 'YYYY')}</span>
                                                            </div>
                                                            <div className="right-controls">
                                                                <span className="zmdi zmdi-chevron-left zmdi-hc-fw" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}></span>
                                                                <span className="zmdi zmdi-chevron-right zmdi-hc-fw" onClick={increaseMonth} disabled={nextMonthButtonDisabled}></span>
                                                            </div>
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="calendar-field">
                                            <label className="field-label"><IntlMessages id="newpatient.deviceReturn"></IntlMessages></label>
                                            <div className="grey-calendar-wrapper">
                                                <DatePicker
                                                    minDate={editPatientForm.device_allocation_date ? dayjs.utc(editPatientForm.device_allocation_date).add(1, 'days').toDate() : dayjs.utc().add(1, 'days').toDate()}
                                                    selected={editPatientForm.device_deallocation_date ? dayjs.utc(editPatientForm.device_deallocation_date).toDate() : dayjs.utc().add(1, 'days').toDate()}
                                                    dateFormat="dd MMM yyyy"
                                                    calendarClassName="custom-calendar grey-calendar"
                                                    customInput={<CustomDateInput />}
                                                    onChange={(date) => {
                                                        setEditPatientForm({ ...editPatientForm, device_deallocation_date: date })
                                                    }}
                                                    renderCustomHeader={({
                                                        date,
                                                        decreaseMonth,
                                                        increaseMonth,
                                                        prevMonthButtonDisabled,
                                                        nextMonthButtonDisabled
                                                    }) => (
                                                        <div className="calendar-controls">
                                                            <div className="left-controls">
                                                                <span>{getLocalMoment(date, 'MMMM')} </span>
                                                                <span>{getLocalMoment(date, 'YYYY')}</span>
                                                            </div>
                                                            <div className="right-controls">
                                                                <span className="zmdi zmdi-chevron-left zmdi-hc-fw" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}></span>
                                                                <span className="zmdi zmdi-chevron-right zmdi-hc-fw" onClick={increaseMonth} disabled={nextMonthButtonDisabled}></span>
                                                            </div>
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="duration-field">
                                            <label className="field-label"><IntlMessages id="newpatient.duration"></IntlMessages> </label>
                                            <div>{
                                                Number(calculatedNights) ? calculatedNights > 1 ?
                                                    calculatedNights + " Nights" :
                                                    calculatedNights + " Night" : "1 Night"}</div>
                                        </div>
                                    </div>
                                    <div className="device-info-right">
                                        <div className="table-search-block patient-table-right">
                                            <div className="device-table-title"><IntlMessages id="dashboard.availableDevices"></IntlMessages></div>
                                            <TextField
                                                variant="outlined"
                                                className="custom-input"
                                                placeholder="Search Device"
                                                value={searchDeviceId}
                                                onChange={(e) => setSearchDeviceId(e.target.value)}
                                                InputProps={{
                                                    classes: {
                                                        root: 'input-field-root'
                                                    }
                                                }}
                                                onKeyPress={(e) => {
                                                    validateSearchText(e);
                                                }}
                                            />
                                        </div>
                                        <div className="device-table">
                                            {deviceData.length > 0 ? <><div className="device-tabel-row transparent-row">
                                                <div className="device-col-1"><IntlMessages id="mypatients.deviceId"></IntlMessages></div>
                                                <div className="device-col-2"><IntlMessages id="newpatient.deviceAvailableFrom"></IntlMessages></div>
                                                <div className="device-col-3"><IntlMessages id="newpatient.deviceAvailableUntil"></IntlMessages></div>
                                                <div className="device-col-4"></div>
                                            </div>
                                                {deviceData.filter(f => f.device_id.toUpperCase().includes(searchDeviceId.toUpperCase())).length === 0 && (
                                                    <div className="device-tabel-row">No record found.</div>
                                                )}
                                                {deviceData.filter(f => f.device_id.toUpperCase().includes(searchDeviceId.toUpperCase())).map((d) => (
                                                    <div key={d.device_id}
                                                        className={"device-tabel-row " + (editPatientForm.device_id == d.device_id ? 'active' : '')}
                                                        onClick={(e) => {
                                                            selectAvailableDevice(e, d.device_id);
                                                        }}
                                                    >
                                                        <div className="device-col-1">{d.device_id}</div>
                                                        <div className="device-col-2">{dayjs(d.device_allocation_date).format("DD MMM YYYY")}</div>
                                                        <div className="device-col-3">{dayjs(d.device_deallocation_date).format("DD MMM YYYY")}</div>
                                                        <div className="device-col-4 radio-group">
                                                            <Radio
                                                                checked={d.selected !== undefined ? d.selected : false}
                                                                disableRipple={true}
                                                                value={d.device_id}
                                                                className="custom-radio"
                                                                icon={<img src={icon_checkbox_round} alt="Icon" />}
                                                                checkedIcon={<img src={icon_checkbox_checked_round} alt="Icon" />}
                                                            />
                                                        </div>
                                                    </div>
                                                ))}</> : <div><IntlMessages id="newpatient.noDeviceFound"></IntlMessages></div>}
                                        </div>
                                    </div>
                                    <div className="device-info-left pl-4">
                                        <label className="field-label star-color-after">
                                            <IntlMessages id="newpatient.timezone"></IntlMessages>
                                        </label>
                                        <TimezoneSelect
                                            timezones={{
                                            ...allTimezones,
                                            }}
                                            labelStyle="original"
                                            value={country.value ? country.value : user.user_details.country}
                                            onChange={v => handleInputChange('country', v.value)}
                                            required={true}
                                            id="country"
                                            name="country"
                                        />
                                        <label className="field-label star-color-after">
                                            <IntlMessages id="newpatient.startTime"></IntlMessages>
                                        </label>
                                        <div>
                                            {deviceWindowStartStopTime.window_start_time ? deviceWindowStartStopTime.window_start_time : 'N/A'}
                                        </div>
                                        <label className="field-label star-color-after">
                                            <IntlMessages id="newpatient.stopTime"></IntlMessages>
                                        </label>
                                        <div>
                                            {deviceWindowStartStopTime.window_end_time ? deviceWindowStartStopTime.window_end_time : 'N/A'}
                                        </div>
                                    </div>
                                </div>

                            </>
                    }
                    <div className="device-information-container">
                        <p className="window_time_change pt-4">
                        <IntlMessages id="editpatient.changeWinTime"></IntlMessages>
                        </p>
                    </div>
                    {
                        !patients.device_info
                        && editDeviceSectionFlag
                        && editPatientForm.device_id
                        && editPatientForm.device_id != ""
                        && (
                            <div className="question-wrap">
                                <div className="question-field">
                                    <label className="question-label"><IntlMessages id="newpatient.implantedActiveDevice"></IntlMessages></label>
                                    <RadioGroup
                                        aria-label="question1"
                                        name="question1"
                                        className="patient-field radio-group"
                                        onChange={(e) => { toggleQuestionHandle('first', e.target.value); }}
                                        value={questionnaire.first}
                                    >
                                        <FormControlLabel
                                            value="no"
                                            control={
                                                <Radio
                                                    disableRipple={true}
                                                    icon={<img src={icon_radio_grey_outline} alt="Icon" />}
                                                    checkedIcon={<img src={icon_radio_grey} alt="Icon" />}
                                                    className="custom-radio"
                                                />
                                            }
                                            label="No"
                                            className="custom-radio-wrap"
                                            classes={{
                                                label: 'custom-radio-label'
                                            }}
                                        />
                                        <FormControlLabel
                                            value="yes"
                                            control={
                                                <Radio
                                                    disableRipple={true}
                                                    icon={<img src={icon_radio_grey_outline} alt="Icon" />}
                                                    checkedIcon={<img src={icon_radio_grey} alt="Icon" />}
                                                    className="custom-radio"
                                                />
                                            }
                                            label="Yes"
                                            className="custom-radio-wrap"
                                            classes={{
                                                label: 'custom-radio-label'
                                            }}
                                        />
                                    </RadioGroup>
                                    {
                                        questionnaire.first === 'yes'
                                        && (
                                            <div className="error-msg">(<IntlMessages id="newpatient.implantedActiveDeviceMsg"></IntlMessages>)</div>
                                        )
                                    }
                                </div>
                                {
                                    questionnaire.first === 'no'
                                    && (
                                        <div className="question-field">
                                            <label className="question-label"><IntlMessages id="newpatient.patientPregnant"></IntlMessages></label>
                                            <RadioGroup
                                                aria-label="question2"
                                                name="question2"
                                                className="patient-field radio-group"
                                                onChange={(e) => { toggleQuestionHandle('second', e.target.value); }}
                                                value={questionnaire.second}
                                            >
                                                <FormControlLabel
                                                    value="no"
                                                    control={
                                                        <Radio
                                                            disableRipple={true}
                                                            icon={<img src={icon_radio_grey_outline} alt="Icon" />}
                                                            checkedIcon={<img src={icon_radio_grey} alt="Icon" />}
                                                            className="custom-radio"
                                                        />
                                                    }
                                                    label="No"
                                                    className="custom-radio-wrap"
                                                    classes={{
                                                        label: 'custom-radio-label'
                                                    }}
                                                />
                                                <FormControlLabel
                                                    value="yes"
                                                    control={
                                                        <Radio
                                                            disableRipple={true}
                                                            icon={<img src={icon_radio_grey_outline} alt="Icon" />}
                                                            checkedIcon={<img src={icon_radio_grey} alt="Icon" />}
                                                            className="custom-radio"
                                                        />
                                                    }
                                                    label="Yes"
                                                    className="custom-radio-wrap"
                                                    classes={{
                                                        label: 'custom-radio-label'
                                                    }}
                                                />
                                            </RadioGroup>
                                            {
                                                questionnaire.second === 'yes'
                                                && (
                                                    <div className="error-msg">(<IntlMessages id="newpatient.patientPregnantMsg"></IntlMessages>)</div>
                                                )
                                            }
                                        </div>
                                    )
                                }
                                {
                                    questionnaire.first === 'no'
                                    && questionnaire.second === 'no'
                                    && (
                                        <div className="question-field">
                                            <label className="question-label"><IntlMessages id="newpatient.underAge"></IntlMessages></label>
                                            <RadioGroup
                                                aria-label="Question3"
                                                name="question3"
                                                className="patient-field radio-group"
                                                onChange={(e) => { toggleQuestionHandle('third', e.target.value); }}
                                                value={questionnaire.third}
                                            >
                                                <FormControlLabel
                                                    value="no"
                                                    control={
                                                        <Radio
                                                            disableRipple={true}
                                                            icon={<img src={icon_radio_grey_outline} alt="Icon" />}
                                                            checkedIcon={<img src={icon_radio_grey} alt="Icon" />}
                                                            className="custom-radio"
                                                        />
                                                    }
                                                    label="No"
                                                    className="custom-radio-wrap"
                                                    classes={{
                                                        label: 'custom-radio-label'
                                                    }}
                                                />
                                                <FormControlLabel
                                                    value="yes"
                                                    control={
                                                        <Radio
                                                            disableRipple={true}
                                                            icon={<img src={icon_radio_grey_outline} alt="Icon" />}
                                                            checkedIcon={<img src={icon_radio_grey} alt="Icon" />}
                                                            className="custom-radio"
                                                        />
                                                    }
                                                    label="Yes"
                                                    className="custom-radio-wrap"
                                                    classes={{
                                                        label: 'custom-radio-label'
                                                    }}
                                                />
                                            </RadioGroup>
                                            {
                                                questionnaire.third === 'yes'
                                                && (
                                                    <div className="error-msg">(<IntlMessages id="newpatient.underAgeMsg"></IntlMessages>)</div>
                                                )
                                            }
                                        </div>
                                    )
                                }
                                {
                                    questionnaire.first === 'no'
                                    && questionnaire.second === 'no'
                                    && questionnaire.third === 'no'
                                    && (
                                        <div className="question-field">
                                            <label className="question-label">I shared the <a href={consent_Form_pdf} target="_blank" rel="noopener noreferrer" >Patient Information Sheet</a> with the patient.</label>
                                            <RadioGroup
                                                aria-label="Question4"
                                                name="question4"
                                                className="patient-field radio-group"
                                                onChange={(e) => { toggleQuestionHandle('forth', e.target.value); }}
                                                value={questionnaire.forth}
                                            >
                                                <FormControlLabel
                                                    value="no"
                                                    control={
                                                        <Radio
                                                            disableRipple={true}
                                                            icon={<img src={icon_radio_grey_outline} alt="Icon" />}
                                                            checkedIcon={<img src={icon_radio_grey} alt="Icon" />}
                                                            className="custom-radio"
                                                        />
                                                    }
                                                    label="No"
                                                    className="custom-radio-wrap"
                                                    classes={{
                                                        label: 'custom-radio-label'
                                                    }}
                                                />
                                                <FormControlLabel
                                                    value="yes"
                                                    control={
                                                        <Radio
                                                            disableRipple={true}
                                                            icon={<img src={icon_radio_grey_outline} alt="Icon" />}
                                                            checkedIcon={<img src={icon_radio_grey} alt="Icon" />}
                                                            className="custom-radio"
                                                        />
                                                    }
                                                    label="Yes"
                                                    className="custom-radio-wrap"
                                                    classes={{
                                                        label: 'custom-radio-label'
                                                    }}
                                                />
                                            </RadioGroup>
                                            {
                                                questionnaire.forth === 'no'
                                                && (
                                                    <div className="error-msg">(<IntlMessages id="newpatient.patientInformationSheetNo"></IntlMessages>)</div>
                                                )
                                            }
                                            {
                                                questionnaire.forth === 'yes'
                                                && (
                                                    <div className="error-msg"><IntlMessages id="newpatient.patientInformationSheetYes"></IntlMessages></div>
                                                )
                                            }
                                        </div>
                                    )
                                }
                            </div>
                        )
                    }
                    {
                        patients.patient_history
                        && patients.patient_history.length > 0
                        && patients.patient_history.filter(f => f.is_device_returned).length > 0
                        && (
                            <div className="sub-section">
                                <div className="section-subtitle"><IntlMessages id="mypatient.deviceHistory"></IntlMessages></div>
                                <div className="field-group view-field-group">
                                    <div className="field-block">
                                        <label className="field-label"><IntlMessages id="mypatients.deviceId"></IntlMessages></label>
                                    </div>
                                    <div className="field-block">
                                        <label className="field-label"><IntlMessages id="mypatients.allocationDate"></IntlMessages></label>
                                    </div>
                                    <div className="field-block">
                                        <label className="field-label"> <IntlMessages id="mypatients.returnDate"></IntlMessages></label>
                                    </div>
                                    <div className="field-block">
                                        <label className="field-label"><IntlMessages id="newpatient.duration"></IntlMessages></label>
                                    </div>
                                    <div className="field-block">
                                        <label className="field-label"><IntlMessages id="newpatient.startTime"></IntlMessages></label>
                                    </div>
                                    <div className="field-block">
                                        <label className="field-label"><IntlMessages id="newpatient.stopTime"></IntlMessages></label>
                                    </div>
                                </div>
                                {
                                    patients.patient_history
                                        .filter(f => f.is_device_returned)
                                        .map((ph, i) => {
                                            const diff = ((new Date(ph.device_deallocation_date).getTime() - (new Date(ph.device_allocation_date).getTime())) / 86400000);
                                            return (
                                                <div key={'ph-' + i} className="field-group view-field-group">
                                                    <div className="field-block">
                                                        <div>{ph.device_id}</div>
                                                    </div>
                                                    <div className="field-block">
                                                        <div>{dayjs(ph.device_allocation_date).format('DD MMM YYYY')}</div>
                                                    </div>
                                                    <div className="field-block">
                                                        <div>{dayjs(ph.device_deallocation_date).format('DD MMM YYYY')}</div>
                                                    </div>
                                                    <div className="field-block">
                                                        <div>{Math.round(Math.abs(diff))} Night(s)</div>
                                                    </div>
                                                    <div className="field-block">
                                                        <div>{ph.window_start_time || 'N/A'}</div>
                                                    </div>
                                                    <div className="field-block">
                                                        <div>{ph.window_end_time || 'N/A'}</div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                }
                            </div>
                        )
                    }
                </div>
                <div className="patient-block view-patient-block reset-password-block" id="edit_patient_device_information">
                    <div className="patient-block-title ">
                        <div className="block-title">
                            <svg xmlns="http://www.w3.org/2000/svg" className="reset-password-icon" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z" clipRule="evenodd" />
                            </svg>
                            <span> Reset patient password</span>
                        </div>
                        {props.is_annotator ? "" : <a
                            href="# "
                            onClick={(e) => {
                                e.persist();
                                e.preventDefault();
                                let notSame = false, ok = true;

                                if ((passwordValues.password && passwordValues.confirm) && passwordValues.password.length && passwordValues.confirm.length) {
                                    if (passwordValues.password !== passwordValues.confirm) {
                                        notSame = true;
                                        ok = false;
                                    }
                                }

                                if (!passwordValues.password || !passwordValues.password.length) {
                                    ok = false
                                }

                                if (!passwordValues.confirm || !passwordValues.confirm.length) {
                                    ok = false
                                }

                                // 
                                setPasswordValues({
                                    passwordError: !Boolean(passwordValues.password),
                                    confirmError: !Boolean(passwordValues.confirm),
                                    notSame
                                })

                                if (ok) {
                                    // console.log('get-details---> ', {
                                    //     patient_id: match.params.id,
                                    //     password: passwordValues.password
                                    // })
                                    props.reset_patient_password({
                                        patient_id: match.params.id,
                                        password: crypto.createHash("md5").update(passwordValues.password).digest("hex")
                                    })
                                }
                            }}
                            className="back-link"
                        >
                            <IntlMessages id="editPatient.resetpassword"></IntlMessages>
                        </a>}
                    </div>
                    <div className="field-group view-field-group">
                        <div className="field-block">
                            <label className="field-label star-color-after"> <IntlMessages id="editPatient.password"></IntlMessages></label>
                            <TextField
                                variant="outlined"
                                name="password"
                                autoComplete="new-password"
                                type="password"
                                className="custom-input"
                                id="reset-password-field"
                                onChange={(e) => {
                                    setPasswordValues({
                                        password: e.target.value,
                                        passwordError: false,
                                        notSame: false,
                                        errorResetting: false,
                                        resetDone: false
                                    })
                                }}
                            />
                            {passwordValues.passwordError && <span className="error-msg"><IntlMessages id="editPatient.cannotBeEmpty"></IntlMessages></span>}
                        </div>
                        <div className="field-block">
                            <label className="field-label star-color-after"><IntlMessages id="editPatient.confirmPassword"></IntlMessages></label>
                            <TextField
                                variant="outlined"
                                type="password"
                                name="confirm-password"
                                autoComplete="new-password"
                                className="custom-input"
                                id="reset-password-confirm-field"
                                onChange={(e) => {
                                    setPasswordValues({
                                        confirm: e.target.value,
                                        confirmError: false,
                                        notSame: false,
                                        errorResetting: false,
                                        resetDone: false
                                    })
                                    // if (e.target.value === "" || (e.target.value.length < 7)
                                    // ) {
                                    //     if (Number.isInteger(e.target.value)) {
                                    //         if (e.target.value.length < 4) {
                                    //             setEditPatientForm({ ...editPatientForm, weight: e.target.value });
                                    //             setFormErrors({ ...formErrors, weightError: "" })
                                    //         }
                                    //     } else {
                                    //         if (new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(e.target.value) || new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(e.target.value)) {
                                    //             setEditPatientForm({ ...editPatientForm, weight: e.target.value });
                                    //             setFormErrors({ ...formErrors, weightError: "" })
                                    //         }
                                    //     }
                                    // }
                                }}
                            />
                            {(
                                passwordValues.confirmError && <span className="error-msg"><IntlMessages id="editPatient.cannotBeEmpty"></IntlMessages></span>
                            )}
                        </div>
                    </div>
                    <div className="error-msg">
                        {passwordValues.notSame && 'The fields are not same.'}
                        {passwordValues.errorResetting && 'Error resetting the password.'}
                    </div>
                    <div className="success-msg" >
                        {passwordValues.resetDone && 'Password reset done.'}
                    </div>
                </div>
            </div>
            <PastDateAllocationDevice
                isOpen={pastDateAllocation}
                deployError={formErrors.deviceError}
                patientId={patients.patient_info ? patients.patient_info.user_id : ''}
                patientCode={patients.patient_info ? patients.patient_info.patient_code : ''}
                deviceId={editPatientForm.device_id}
                allocationDate={dayjs(pastDate).format("DD MMM YYYY")}
                deallocationDate={dayjs(editPatientForm.device_deallocation_date).format("DD MMM YYYY")}
                page={'edit-patient'}
                deployDevice={() => {
                    setPastDateAllocation(false)
                    setEditPatientForm({
                        ...editPatientForm,
                        device_allocation_date: pastDate
                    })
                }}
                handleSuccessDeploy={() => {
                    // setPastDateSuccess(true);

                }}
                onCancel={() => {
                    // NOTE: flushes existing response errors and removes the dialog
                    //       so user can select other device
                    props.reset_device_operation_response();
                    setFormErrors({ ...formErrors, deviceError: null })
                    setPastDateAllocation(false);
                }}
            />
        </div>
    )
};

const mapStateToProps = (state) => ({
    patients: state.patients ? state.patients : null,
    patient_fetching: state.patients ? state.patients.data_fetching : false,
    user: state.user,
    is_annotator: state.user.is_annotator,
    doctor_id: state.user.user_details.user_id,
});

const mapDispatchToProps = dispatch => ({
    reset_patient_password_state: () => dispatch(reset_patient_password_state_action()),
    reset_patient_password: (payload) => dispatch(reset_patient_password_action(payload)),
    fetch_patient_data: (patient_id) => dispatch(fetch_patient_data_action(patient_id)),
    fetch_disease_list: (payload) => dispatch(fetch_disease_list_action(payload)),
    set_patient_info_null: () => dispatch(set_patient_info_null_action()),
    fetch_patient_data_loading: () => dispatch(fetch_patient_data_loading_action()),
    fetch_patient_disease: (payload) => dispatch(fetch_patient_disease_action(payload)),
    generate_patient_id: () => dispatch(generate_patient_id_action()),
    fetch_available_devices: (payload) => dispatch(fetch_available_devices_action(payload)),
    update_patient_info: (payload) => dispatch(update_patient_info_action(payload)),
    fetch_available_devices_dates: () => dispatch(fetch_available_devices_dates_action()),
    reset_device_operation_response: () => dispatch(reset_device_operation_response_action())
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewPatientInfo);